import { render } from "./Leaderboard.vue?vue&type=template&id=3891bb5f&scoped=true&ts=true"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"

import "./Leaderboard.vue?vue&type=style&index=0&id=3891bb5f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3891bb5f"]])

export default __exports__